import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { NavLink, Tooltip } from '@mantine/core';

import { menu } from './menu-sections';
import classes from './sidebar.module.css';

export function Sidebar() {
  const { pathname } = useLocation();

  // Flatten all sections into a single array of items
  const menuItems = menu.flatMap(item => item.section);

  return (
    <div className={classes.menuWrapper} >
      {menuItems.map((item) => (
        <Tooltip
          key={item.name}
          label={item.name}
          position="right"
          withArrow
        >
          <NavLink
            key={item.name}
            variant="light"
            component={RouterLink}
            to={item.href}
            active={
              item.href === '/' ? pathname === '/' : (
                pathname.includes(item.href) || 
                item.hrefAliases?.some(alias => {
                  const basePath = alias.split(':')[0];
                  return pathname.includes(basePath);
                })
              )
            }
            className={classes.sectionLink}
            leftSection={item.icon && <item.icon size="1rem" />}
          />
        </Tooltip>
      ))}
    </div>
  );
}
